import React from 'react'
import styles from './ConfirmModal.module.css'

/**
 * 확인/취소 버튼이 있는 확인 모달
 * @param {boolean} isOpen - 모달 열림/닫힘 상태
 * @param {function} onClose - 모달 닫기 콜백 (취소 버튼 클릭 시)
 * @param {function} onConfirm - 확인 버튼 클릭 시 콜백
 * @param {string} message - 표시할 메시지
 * @param {string} title - 모달 제목 (선택사항)
 * @param {string} confirmText - 확인 버튼 텍스트 (기본값: "예")
 * @param {string} cancelText - 취소 버튼 텍스트 (기본값: "취소")
 * @param {string} confirmButtonColor - 확인 버튼 색상 (기본값: "#7c3aed")
 */
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  title,
  confirmText = '예',
  cancelText = '취소',
  confirmButtonColor = '#7c3aed'
}) => {
  if (!isOpen) return null

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className={styles.header}>
            <h2>{title}</h2>
          </div>
        )}
        <div className={styles.message}>
          <p>{message}</p>
        </div>
        <div className={styles.actions}>
          <button className={styles.cancelButton} onClick={onClose}>
            {cancelText}
          </button>
          <button
            className={styles.confirmButton}
            onClick={handleConfirm}
            style={{ backgroundColor: confirmButtonColor }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
